const styles = () => ({
  fields: {
    minHeight: 450,
  },
  logo: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: 14,
    marginRight: 12,
  },
});

export default styles;
